module.exports = __webpack_public_path__ + "static/media/web logos_Brunel.65782f16.jpg";